import React from 'react';
import './NotificationDisplay.css';

interface WarningDisplayProps {
  message: string;
  className?: string;
  onClose?: () => void;
}

const WarningDisplay: React.FC<WarningDisplayProps> = ({ message, className = '', onClose }) => {
  if (!message) return null;

  return (
    <div className={`warning-display ${className}`}>
      <div className="warning-container">
        <div className="warning-header">
          <div className="warning-header-left">
            <i className="fas fa-exclamation-triangle warning-icon"></i>
            <span className="warning-title">Warning</span>
          </div>
          {onClose && (
            <button 
              type="button" 
              className="warning-close-btn"
              onClick={onClose}
              aria-label="Close warning message"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
        <div className="warning-message">
          {message}
        </div>
      </div>
    </div>
  );
};

export default WarningDisplay; 